import axios from 'axios';
axios.defaults.withCredentials = false;


const AvafinAxios = axios.create({
    //baseURL:"http://46.105.108.42:9066/",
    baseURL:"https://www.sodesoft.net:9077/",
    crossdomain: true,
    redirect: "follow", 
    headers: {
        //"referer": "no-referer",
        //'Access-Control-Allow-Origin': '*',
        "Accept": "application/json",
        "Content-Type": "application/json; charset=utf-8"
    }
});

const ArcsAxios = axios.create({
    //baseURL:"http://46.105.108.42:9062/",
    baseURL:"https://www.sodesoft.net:9072/",
    crossdomain: true,
    redirect: "follow", 
    headers: {
        "Accept": "application/json",
        "Content-Type": "application/json; charset=utf-8"
    }
});



export default{
  AvafinAxios,
  ArcsAxios
};
